<template>
  <div>
    <div class="corner-ribbon top-left red shadow" v-if="$consts.ENV !== 'PRODUCTION'">
      <span>{{ $consts.ENV }}</span>
    </div>
    <v-app-bar color="primary" app dark flat>
      <v-app-bar-nav-icon @click.stop="$store.commit('main/lToggle')" v-show="isShow"></v-app-bar-nav-icon>
      <!-- <v-toolbar-title>
        SIA PBB JATIM
      </v-toolbar-title> -->
      <v-spacer></v-spacer>
      <!-- <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn outlined color="white" dark v-on="on">Download SOP</v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in itemSops" :key="index" @click="item.click()">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>-->
      <v-avatar @click.stop="$store.commit('main/rToggle')" background-color="primary">
        <a>
          <v-avatar :size="40" color="white">
            <img v-if="user.foto" :src="user.foto | 'img/avatar-default'" alt="avatar" />
            <v-icon v-else large color="primary">mdi-account-circle</v-icon>
          </v-avatar>
        </a>
      </v-avatar>
    </v-app-bar>
  </div>
</template>

<script>
// import PilihInstansi from "../modules/instansi/components/PilihInstansiDialog";
export default {
  components: {
    // PilihInstansi
  },
  data() {
    return {
      sidebar: false,
      avatar: null,
      menu: false,
      // message : 'asdasd',
      // fav : false,
      loading: false
    };
  },
  computed: {
    // totalInstansi() {
    //   return this.$store.getters["main/totalInstansi"];
    // },
    user() {
      let u = this.$store.getters["user/user"];
      // if(u.file_foto.data==null){
      //   u.file_foto=null
      // }

      // eslint-disable-next-line

      return u ? u : null;
    },
    isShow() {
      return this.$route.name !== "instansi.pilih";
    }
    // instansiTerpilih() {
    //   let i = this.$store.getters["instansi/instansi_aktif"];
    //   if (i && i.roleku && i.roleku.id == 3) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
  },
  methods: {
    clickDrawer() {
      this.$emit("dclicked");
    },
    // pilihInstansi() {
    //   this.$refs.dlg
    //     .open()
    //     .then(res => res)
    //     .catch(e => e);
    // },
    logout() {
      this.loading = true;
      this.$store
        .dispatch("user/logout")
        .then(() => {
          this.menu = false;
          this.loading = false;
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    // hSidebar(n) {
    //   this.sidebar = n;
    // }
  }
};
</script>
<style>
.corner-ribbon.shadow {
  -webkit-box-shadow: 1px 2px 3px #474747;
  box-shadow: 1px 2px 3px #474747;
}
.corner-ribbon.top-left {
  top: 15px;
  left: -50px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
.corner-ribbon.red {
  background: #e43;
}
.corner-ribbon {
  width: 150px;
  background: pink;
  position: fixed;
  text-align: center;
  letter-spacing: 1px;
  color: #f0f0f0;
  z-index: 10;
  font-weight: 600;
  font-size: 12px;
  text-shadow: 1px 1px 1px #474747;
  letter-spacing: 0.1em;
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 1140px;
  }
  .v-btn:hover:before {
    background-color: transparent;
  }
  .v-btn:hover:after {
    background-color: transparent;
    color: blue;
  }
}
</style>
